import { message, Select } from "antd";
import _, { startCase } from "lodash";
import { MinusCircleFilled, PlusSquareFilled } from "@ant-design/icons";
import React, { useMemo } from "react";
import Card from "./Card";
import ReadyOrdersCard from "./ReadyOrdersCard";
import { useParams } from "react-router-dom";
import CompletedOrders from "../completedOrders";

const ContentSection = (props) => {
  const {
    wrapperRef,
    zooming,
    setZooming,
    currentFilter,
    kitchenData,
    setCurrentFilter,
    onAcknoledgeOrder,
    selectedMenuItemId,
    handleUpdateCartItem,
    setShowCompleted,
    showCompleted
  } = props;
  const params = useParams();

  const zoomIn = () => {
    let currentZoom = parseInt(
      wrapperRef.current?.style?.zoom?.replace("%", "") || "100"
    );
    if (currentZoom < 130) {
      wrapperRef.current.style.zoom = currentZoom + 5 + "%";
      setZooming(currentZoom + 5 + "%");
    } else {
      message.warning("Maximum zoom limit reached");
    }
  };
  const zoomOut = () => {
    let currentZoom = parseInt(
      wrapperRef.current?.style?.zoom.replace("%", "") || "100"
    );
    if (currentZoom > 70) {
      wrapperRef.current.style.zoom = currentZoom - 5 + "%";
      setZooming(currentZoom - 5 + "%");
    } else {
      message.warning("Minimum zoom limit reached");
    }
  };

  const ordersToShow =  useMemo(() => {
    const ksi = kitchenData.map((items) => {
      // debugger
      return items.filter((item) => item.is_sent_to_kitchen);
    });
    if (currentFilter) {
      return ksi.map((items) => {
        return items.filter(item => item.kitchen_priority === currentFilter);
      });
    }
    return ksi;
  }, [kitchenData, currentFilter]);

  console.log('ordersToShow ksi', ordersToShow)

  return (
    <div>
      <div className="title_header">
        <h2 className="title">{`${startCase(params.stationName)} Station`}</h2>
        <div>
          <span className="label">Zoom: </span>
          <MinusCircleFilled onClick={zoomOut} />
          <span className="zoomval">{zooming}</span>
          <PlusSquareFilled onClick={zoomIn} />
        </div>
      </div>
      <div className="filter_head">
        <div className="filter_sec">
          <div
            className={currentFilter ? "filter_box" : "filter_box border"}
            onClick={() => {
              setCurrentFilter("");
            }}
          >
            All Orders
          </div>
          <div
            className={
              currentFilter === "HIGH"
                ? "filter_box high border"
                : "filter_box high"
            }
            onClick={() => {
              setCurrentFilter("HIGH");
            }}
          >
            Hign Priority
          </div>
          <div
            className={
              currentFilter === "MEDIUM"
                ? "filter_box medium border"
                : "filter_box medium"
            }
            onClick={() => {
              setCurrentFilter("MEDIUM");
            }}
          >
            Medium Priority
          </div>
          <div
            className={
              currentFilter === "LOW"
                ? "filter_box low border"
                : "filter_box low"
            }
            onClick={() => {
              setCurrentFilter("LOW");
            }}
          >
            Low Priority
          </div>
          <div className="border_l" />
            <div className={showCompleted ? "filter_box complete border" : "filter_box complete" }
              onClick={()=>{setShowCompleted(!showCompleted)}}
            >Completed Orders</div>
          </div>
      </div>
      <div className="yetsend_sec">
        <div className="card_wrap">
          {ordersToShow.map((orders, i) => (
            <Card
              key={i}
              cardData={orders.filter((cart_item) => cart_item.is_kitchen_acknowledged)}
              expoGroup={orders.priority}
              selectedMenuItemId={selectedMenuItemId}
              handleUpdateCartItem={handleUpdateCartItem}
            />
          ))}
        </div>
      </div>
      <div className="yetsend_sec">
        <div className="sub_title">Ready Orders</div>
        <div className="card_wrap">
          {ordersToShow.map((orders) => {
            return (
              <ReadyOrdersCard
                cardData={orders.filter((cart_item) => !cart_item.is_kitchen_acknowledged)}
                onAcknoledgeOrder={onAcknoledgeOrder}
              />
            );
          })}
        </div>
      </div>
      {showCompleted && 
      <div className="yetsend_sec">
        <div className="sub_title">Completed orders</div>
        <div className="">
          <CompletedOrders />
        </div>
      </div>}
    </div>
  );
};
export default ContentSection;
